import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { C, Btn, Input } from "../components/UI";

export default function Configuracoes() {
  const navigate = useNavigate();
  const { logout } = useApp();
  
  const [notificacoes, setNotificacoes] = useState({
    email_vagas: true,
    email_avaliacoes: true,
    email_newsletter: false,
    push_vagas: true,
    push_mensagens: true
  });

  const [privacidade, setPrivacidade] = useState({
    perfil_publico: true,
    mostrar_curriculo: true,
    mostrar_avaliacoes: false
  });

  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const handleAlterarSenha = () => {
    if (novaSenha !== confirmarSenha) {
      alert("As senhas nao coincidem!");
      return;
    }
    alert("Senha alterada com sucesso!");
    setSenhaAtual("");
    setNovaSenha("");
    setConfirmarSenha("");
  };

  const handleExcluirConta = () => {
    if (window.confirm("Tem certeza que deseja excluir sua conta? Esta acao nao pode ser desfeita.")) {
      alert("Conta excluida. Voce sera redirecionada.");
      logout();
      navigate("/");
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg }}>
      {/* Header */}
      <section style={{ background: C.roseMid, padding: "60px 20px 40px", textAlign: "center" }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 36, color: "#fff", marginBottom: 8 }}>
          Configuracoes
        </h1>
        <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 16 }}>
          Gerencie suas preferencias de conta
        </p>
      </section>

      <section style={{ maxWidth: 700, margin: "0 auto", padding: "40px 20px" }}>
        {/* Notificacoes */}
        <div style={{ 
          background: C.surface, 
          borderRadius: 16, 
          padding: 24, 
          border: `1px solid ${C.border}`,
          marginBottom: 24
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: C.textMain, marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }}>
            <span>🔔</span> Notificacoes
          </h2>
          
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <h3 style={{ fontSize: 14, fontWeight: 600, color: C.textSec, marginBottom: 4 }}>E-mail</h3>
            {[
              { id: "email_vagas", label: "Novas vagas compatíveis com meu perfil" },
              { id: "email_avaliacoes", label: "Atualizacoes sobre minhas avaliacoes" },
              { id: "email_newsletter", label: "Newsletter e novidades da WoMom" }
            ].map(item => (
              <label key={item.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}>
                <span style={{ fontSize: 14, color: C.textSec }}>{item.label}</span>
                <input
                  type="checkbox"
                  checked={notificacoes[item.id]}
                  onChange={(e) => setNotificacoes({ ...notificacoes, [item.id]: e.target.checked })}
                  style={{ width: 18, height: 18, accentColor: C.roseMid }}
                />
              </label>
            ))}

            <h3 style={{ fontSize: 14, fontWeight: 600, color: C.textSec, marginTop: 16, marginBottom: 4 }}>Push</h3>
            {[
              { id: "push_vagas", label: "Alertas de novas vagas" },
              { id: "push_mensagens", label: "Mensagens de empresas" }
            ].map(item => (
              <label key={item.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}>
                <span style={{ fontSize: 14, color: C.textSec }}>{item.label}</span>
                <input
                  type="checkbox"
                  checked={notificacoes[item.id]}
                  onChange={(e) => setNotificacoes({ ...notificacoes, [item.id]: e.target.checked })}
                  style={{ width: 18, height: 18, accentColor: C.roseMid }}
                />
              </label>
            ))}
          </div>
        </div>

        {/* Privacidade */}
        <div style={{ 
          background: C.surface, 
          borderRadius: 16, 
          padding: 24, 
          border: `1px solid ${C.border}`,
          marginBottom: 24
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: C.textMain, marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }}>
            <span>🔒</span> Privacidade
          </h2>
          
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {[
              { id: "perfil_publico", label: "Perfil visível para empresas", desc: "Empresas podem ver seu nome e area de atuacao" },
              { id: "mostrar_curriculo", label: "Permitir visualizacao do curriculo", desc: "Empresas com plano ativo podem ver seu curriculo completo" },
              { id: "mostrar_avaliacoes", label: "Mostrar minhas avaliacoes publicamente", desc: "Suas avaliacoes aparecerao com seu nome" }
            ].map(item => (
              <div key={item.id} style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                <div>
                  <label style={{ fontSize: 14, color: C.textMain, fontWeight: 500, cursor: "pointer" }}>{item.label}</label>
                  <p style={{ fontSize: 12, color: C.textSec, marginTop: 2 }}>{item.desc}</p>
                </div>
                <input
                  type="checkbox"
                  checked={privacidade[item.id]}
                  onChange={(e) => setPrivacidade({ ...privacidade, [item.id]: e.target.checked })}
                  style={{ width: 18, height: 18, accentColor: C.roseMid, marginTop: 2 }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Alterar Senha */}
        <div style={{ 
          background: C.surface, 
          borderRadius: 16, 
          padding: 24, 
          border: `1px solid ${C.border}`,
          marginBottom: 24
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: C.textMain, marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }}>
            <span>🔑</span> Alterar Senha
          </h2>
          
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Input 
              label="Senha atual" 
              name="senha_atual"
              type="password" 
              value={senhaAtual} 
              onChange={(e) => setSenhaAtual(e.target.value)} 
            />
            <Input 
              label="Nova senha" 
              name="nova_senha"
              type="password" 
              value={novaSenha} 
              onChange={(e) => setNovaSenha(e.target.value)} 
            />
            <Input 
              label="Confirmar nova senha" 
              name="confirmar_senha"
              type="password" 
              value={confirmarSenha} 
              onChange={(e) => setConfirmarSenha(e.target.value)} 
            />
            <Btn variant="primary" onClick={handleAlterarSenha} style={{ alignSelf: "flex-start" }}>
              Alterar senha
            </Btn>
          </div>
        </div>

        {/* Zona de Perigo */}
        <div style={{ 
          background: "#FEF2F2", 
          borderRadius: 16, 
          padding: 24, 
          border: "1px solid #FECACA"
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: "#DC2626", marginBottom: 12, display: "flex", alignItems: "center", gap: 10 }}>
            <span>⚠️</span> Zona de Perigo
          </h2>
          <p style={{ fontSize: 14, color: "#7F1D1D", marginBottom: 16 }}>
            Ao excluir sua conta, todos os seus dados serao permanentemente removidos. Esta acao nao pode ser desfeita.
          </p>
          <button
            onClick={handleExcluirConta}
            style={{
              padding: "10px 20px",
              borderRadius: 8,
              border: "1px solid #DC2626",
              background: "transparent",
              color: "#DC2626",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.15s"
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "#DC2626"; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#DC2626"; }}
          >
            Excluir minha conta
          </button>
        </div>
      </section>
    </div>
  );
}
